import {useEffect, useState} from "react";
import valuer_api from "../../../api/valuer";
import ValuerAmendTableFreeText from "./ValuerAmendTableFreeText";


const ValuerAmendTableSizeColumn = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.section
    const identifier = props.identifier
    const rowIdentifier = props.rowIdentifier
    const columnIdentifiers = props.columnIdentifiers

    const [rowValues, setRowValues] = useState({})

    const addedText = props.addedText

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.rowValues !== undefined) setRowValues(props.rowValues);
    }, [props.rowValues])

    return (
        <div className="valuer-amend-table-columns-container">
            {columnIdentifiers && columnIdentifiers.map((columnIdentifier, idx) => {
                return (
                    <>
                        <div className="valuer-amend-table-sub-column">
                            <ValuerAmendTableFreeText summaryId={summaryId}
                                                      section={section}
                                                      identifier={identifier}
                                                      columnIdentifier={columnIdentifier}
                                                      rowIdentifier={rowIdentifier}
                                                      rowValues={rowValues}
                                                      UpdateParentValue={UpdateParentValue}
                                                      AddToQueue={AddToQueue}
                                                      RemoveFromQueue={RemoveFromQueue}
                                                      AddToErroredSaves={AddToErroredSaves}
                                                      setErrorMessage={setErrorMessage}
                                                      setErrorTitle={setErrorTitle}

                            />
                            <div className="valuer-amend-table-columns-added-text">
                                {addedText && addedText[idx]}
                            </div>
                        </div>
                        {columnIdentifiers && idx+1 !== columnIdentifiers.length ?
                            <div className="valuer-amend-column-divider"/>
                            : null
                        }

                    </>


                )
            })}
        </div>

    )
}

export default ValuerAmendTableSizeColumn;